import React from 'react';
import { Theme } from '@emotion/react';
import { Button, SxProps } from '@mui/material';
import { Colors, createMainButton } from '../../../utils/theme';
import { predefinedFonts } from '../../../utils/fontStyles';

interface IProps {
  id: string;
  text: string;
  disabled?: boolean;
  onClick: () => void;
  sx?: SxProps<Theme> | undefined;
  type?: 'transperant' | 'secondary';
}

const ToolBarButton: React.FunctionComponent<IProps> = ({
  id,
  text,
  disabled = false,
  onClick,
  sx,
  type = 'transperant'
}: IProps) => {
  const getStyle = (): SxProps<Theme> => {
    if (type === 'transperant') {
      return {
        width: '125px',
        height: '36px',
        color: Colors.white,
        border: '1px solid ' + Colors.white,
        background: 'transparent',
        marginRight: '10px',
        textTransform: 'uppercase',
        borderRadius: '10px',
        ...predefinedFonts.semiBold14px22px,
        ...sx
      } as SxProps<Theme>;
    } else {
      return {
        ...createMainButton,
        width: '125px',
        height: '36px',
        color: Colors.white,
        ...sx
      } as SxProps<Theme>;
    }
  };
  return (
    <Button id={id} data-testid={id} sx={getStyle()} disabled={disabled} onClick={onClick}>
      {text}
    </Button>
  );
};

export default ToolBarButton;
